import React, {lazy, Suspense} from 'react'
import {Switch, Route} from 'react-router-dom'
import {Typography} from 'antd'
import typo, { MESSAGE } from "../../constants/dictionaries";
import { groupFunctionsCode, functionsCode } from "../../constants/constant";
const {Title} = Typography;

// Components
const QTVinhHaLong = lazy(() => import('./QTVinhHaLong'));
const TramQuanTrac = lazy(() => import('./TramQuanTrac'));

export default ({match}) => {
  return (
    <Suspense fallback={() => <Title level={4}>Loading</Title>}>
      <Switch>
        <Route exact path={`${match.path}/bao-cao-dinh-ky`} render={(props)=> <QTVinhHaLong {...props} phanquyen={functionsCode.QTVHL} ThanhPhanMT={9} title={typo.cscore_draw_qtvinhhalong} />}/>
        <Route exact path={`${match.path}/tram-quan-trac`} render={(props)=> <TramQuanTrac {...props} />}/>

      </Switch>
    </Suspense>
  )
}